import { Component, OnInit, Inject } from '@angular/core';
import { UnitsService } from 'src/app/services/units.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UnitDetailsComponent } from '../unit-details/unit-details.component';
import { MainService } from 'src/app/services/main.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.css']
})
export class AddCardComponent implements OnInit {

  cardtype_arr: any = []
  cardId: any = ''
  cardType: any
  cards_arr :any = []
  RfidForm: FormGroup | any;
  accsess_Type:any
  constructor(private rest: UnitsService,
    private mainService : MainService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<UnitDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ) { }

  ngOnInit() {
    this.cardsList(this.data.id)
    this.getCardType()
    this.initRfidForm()
  }

  initRfidForm() {
    this.RfidForm = this.formBuilder.group({
      front: ['', Validators.required],
      front_source: [''],
      back_source: [''],
      back: ['', Validators.required],
      charOne: ['', Validators.required],
      charTow: ['', Validators.required],
      charThree: ['', Validators.required],
      number: ['', Validators.required],
      serial_number: ['', [Validators.required]],
      card_id: ['', [Validators.required]]
    });
  }

  getCardType() {
    this.rest.cardType().subscribe((res: any) => {
      console.log(res)
      res.children.forEach((element: any) => {
        if (element.name == 'RFID') {
          this.accsess_Type = element.id;
        }
        if(element.name == 'Mifare'){
          this.cardtype_arr.push(element)
        }else if (element.name == 'Proximity'){
          this.cardtype_arr.push(element)
          this.cardType = element.id
        }
      });
      // this.cardtype_arr = res.children[0].children
      // this.cardtype_arr.push(res.children[res.children.length - 1])
      // this.cardType = res.children[res.children.length - 1].id
      console.log(  this.cardtype_arr)
    })
  }

  radioChange(e: any) {
    console.log(e.target.value)
    this.cardType = e.target.value
  }

  addCard() {
    if(this.cardType == "RFID"){
      this.addRfid()
    }else {
      this.cardType =+ this.cardType
      let data = {
        type_id: this.cardType,
        card_id: this.cardId
      }
      this.dialogRef.close(data);
    }
  
  }

  cardsList(id:any){
    this.rest.cardsList(id).subscribe((res:any) => {
      console.log(res)
      this.cards_arr = res
    })
  }

  deletCard(value:any){
    this.rest.deleteCard(value.id).subscribe((res:any) => {
      console.log(res)
      this.mainService.SuccessToast('Card Deleted')
      this.cardsList(this.data.id)
    })
  }

  onFileChange(e: any, name: any) {
    const file = e.target.files[0];
    if (name == 'front') {
      this.RfidForm.patchValue({
        front_source: file
      });
    } else {
      this.RfidForm.patchValue({
        back_source: file
      });
    }
  }

  addRfid() {
    let RfidData = this.RfidForm.value;
    RfidData.number =  Intl.NumberFormat('ar-SA',{
    }).format(RfidData.number);
    RfidData.number = RfidData.number.replace('٬','')
    let data = {
      front: RfidData.front_source,
      back: RfidData.back_source,
      type_id : this.accsess_Type,
      card_id: RfidData.card_id,
      license_plate: RfidData.charThree + ' ' + RfidData.charTow + ' ' +  RfidData.charOne + RfidData.number  ,
      serial_number: RfidData.serial_number
    };
    this.dialogRef.close(data);
  }
}
